export default "__VITE_ASSET__CvJKA77h__"